import { ChallengeService } from '@duck/api-definitions'
import { RelativeDateTime } from '@components/datetime'
import {
} from '@duck/ui'
import { LastWorkSave } from './LastWorkSave'
import { useTar } from '@/modules'
import { taskDifficultyDisplayMap } from '@/utils/challengeData.utils'

interface InformationBarProps {
  challenge: ChallengeService.Challenge
  task: ChallengeService.Task
  workTime: number
}

export const WorkspaceHeaderPane = ({ challenge, task, workTime }: InformationBarProps) => {
  const { t } = useTar()

  const formatWorkTime = (workTimeMinutes: number) => {
    const hours = Math.floor(workTimeMinutes / 60)
    const minutes = workTimeMinutes % 60
    if (hours > 0) {
      return `${hours}h ${minutes}m`
    }
    return `${minutes}m`
  }

  return (
    <div className="flex w-full py-2 items-center justify-center h-12 bg-card">
      <div className="flex flex-1 items-center justify-between md:px-4">
        <div className="flex items-center" data-tour-id="task-name">
          <span className="font-semibold text-foreground">{t('challenges.challengeTASK_NAME', { taskName: task.name })}</span>
        </div>

        <div className="flex items-center gap-4 flex-col md:flex-row">
          <LastWorkSave />
          <span className="hidden md:block text-foreground">•</span>
          <div className="flex items-center gap-2 hidden xl:flex">
            <span className="text-sm font-medium text-foreground">{t('common.started')}:</span>
            <RelativeDateTime isoDateString={challenge.startTime} className="text-sm text-foreground" />
          </div>
          <span className="hidden xl:block text-foreground">•</span>
          <div className="flex items-center gap-2 hidden md:flex">
            <span className="text-sm font-medium text-foreground">{t('common.workTime')}:</span>
            <span className="text-sm text-foreground">{formatWorkTime(workTime)}</span>
          </div>
          {task.difficulty && (
            <>
              <span className="hidden xl:block text-foreground">•</span>
              <div className="flex items-center gap-2 hidden xl:flex">
                <span className="text-sm font-medium text-foreground">{t('common.difficulty')}:</span>
                <span className="text-sm text-foreground capitalize">{t(taskDifficultyDisplayMap[task.difficulty])}</span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}